<template>
  <div class="software_module">
    <div class="software_list">
      <el-row :gutter="20">
        <el-col :span="2">
          <div class="ctl_arrow">
            <div class="el-icon-arrow-left ctl_arrow_item" @click="back(showArr)"></div>
          </div>
        </el-col>
        <el-col :span="5" v-for="(software,index) in showArr" :key="index">
          <div class="show_list_img" @click="viewSoftware(software.pid)">
            <img :src="software.path" alt="" width="100%" height="222">
          </div>
        </el-col>
        <el-col :span="2">
          <div class="ctl_arrow">
            <div class="el-icon-arrow-right ctl_arrow_item" @click="forward(showArr)"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-divider></el-divider>
    <div class="one_software">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="mainTitle">页面展示</div>
          <div class="sample_page">
            <img :src="softwareObj.softSample" alt="" width="100%" height="100%">
          </div>
        </el-col>
        <el-col :span="18">
          <div class="product_cup">
            <div class="mainTitle">{{softwareObj.softTitle}}</div>
            <div class="software_text " v-html="softwareObj.softText"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { oneProductInfo, productList } from '@/api/frontApi/product';
export default {
  data() {
    return {
      productArr: [
        { path: '../../../../static/img/product/technology-1.png', index: 1 },
        { path: '../../../../static/img/product/technology-2.png', index: 2 },
        { path: '../../../../static/img/product/technology-3.png', index: 3 },
        { path: '../../../../static/img/product/technology-4.png', index: 4 }
      ],
      samplePage: [
        { path: '../../../../static/img/product/technology-1.png' },
        { path: '../../../../static/img/product/technology-1.png' }
      ],
      softwareObj: {
        softText: '',
        softShowSrc: '',
        softTitle: '',
        softSample: ''
      },
      showArr: []
    };
  },
  created() {
    this.softwareList();
  },
  methods: {
    softwareList() {
      // proType 1软件
      productList(1).then(res => {
        if (res.data.length > 0) {
          this.productArr = [];
          res.data.forEach(item => {
            let tempObj = { path: '', pid: 0, name: '' };
            tempObj.name = item.proTitle;
            tempObj.path = item.picMain;
            tempObj.pid = item.proId;
            this.productArr.push(tempObj);
          });
          this.showArr = this.productArr.slice(0, 4);
          this.viewSoftware(this.productArr[0].pid);
        }
      });
    },
    viewSoftware(softwareId) {
      if (softwareId) {
        oneProductInfo(parseInt(softwareId)).then(res => {
          this.softwareObj.softText = res.data.proBody;
          this.softwareObj.softTitle = res.data.proTitle;
          this.softwareObj.softShowSrc = res.data.picMain;
          this.softwareObj.softSample = res.data.picPara;
        });
      }
    },
    goAuthor(type) {
      switch (type) {
        case 1:
          this.showArr = this.forward(this.showArr);
          break;
        case 2:
          this.showArr = this.back(this.showArr);
          break;
      }
    },
    forward(arrayObj3) {
      let tempLen = arrayObj3.length;
      if (
        arrayObj3[tempLen - 1].pid ===
        this.productArr[this.productArr.length - 1].pid
      ) {
        arrayObj3.shift();
        arrayObj3.push(this.productArr[0]);
      } else {
        for (let q = 0; q < this.productArr.length; q++) {
          if (arrayObj3[tempLen - 1].pid === this.productArr[q].pid) {
            arrayObj3.shift();
            arrayObj3.push(this.productArr[q + 1]);
            break;
          }
        }
      }
      return arrayObj3;
    },
    back(arrayObj4) {
      let tempLen = arrayObj4.length;
      let tempObj = arrayObj4[tempLen - 1];
      if (arrayObj4[0].pid === this.productArr[0].pid) {
        arrayObj4.pop();
        arrayObj4.unshift(this.productArr[tempLen]);
      } else {
        for (let q = 0; q < this.productArr.length; q++) {
          if (tempObj.pid === this.productArr[q].pid) {
            arrayObj4.pop();
            if (q === this.productArr.length - 1) {
              arrayObj4.unshift(this.productArr[0]);
            } else {
              arrayObj4.unshift(this.productArr[q + 1]);
            }
            break;
          }
        }
      }
      return arrayObj4;
    },
    productModuleShow() {}
  }
};
</script>
<style lang="stylus" scoped>
.software_module {
  width: 100%;

  .software_list {
    width: 100%;
    magin-bottom: 20px;
  }

  .one_software {
    background-color: #fff;
    padding: 20px 15px;
    border: 1px solid #fff;

    .sample_page {
      padding-top: 10px;
    }
  }

  .show_list_img {
    cursor: pointer;
  }
}

.product_cup {
  width: 100%;

  .software_text {
    line-height: 30px;
    color: #000;
    width: 100%;
  }

  .software_text>>>p {
    text-indent: 2em;
  }

  .software_text>>>p img {
    display: block;
    max-width: 80%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/product/softwareObj.vue